import { UserBasedItemRestraints } from '../user-item.restraints';
export class CompanyAddressRestraints extends UserBasedItemRestraints {
  canViewItem(item) {
    if (this.isExecutedBySystem() || this.hasRole('ADMINISTRATOR')) return true;
    if (this.hasRole('MANAGER') && this.userManagesCompany(item.companyId)) return true;
    return 'Sie haben keine Berechtigung, diese Adresse einzusehen';
  }
  canCreateItem(item) {
    if (this.isExecutedBySystem() || this.hasRole('ADMINISTRATOR')) return true;
    if (this.hasRole('MANAGER') && this.userManagesCompany(item.companyId)) return true;
    return 'Sie haben keine Berechtigung, diese Adresse zu erstellen';
  }
  canToggleItem(item) {
    if (this.isExecutedBySystem() || this.hasRole('ADMINISTRATOR')) return true;
    if (this.hasRole('MANAGER') && this.userManagesCompany(item.companyId)) return true;
    return 'Sie haben keine Berechtigung, diese Adresse zu bearbeiten';
  }
  canUpdateItem(item, oldItem) {
    if (this.isExecutedBySystem() || this.hasRole('ADMINISTRATOR')) return true;
    if (this.hasRole('MANAGER') && this.userManagesCompany(item.companyId)) return true;
    return 'Sie haben keine Berechtigung, diese Adresse zu bearbeiten';
  }
  canRemoveItem(item) {
    if (this.isExecutedBySystem() || this.hasRole('ADMINISTRATOR')) return true;
    if (this.hasRole('MANAGER') && this.userManagesCompany(item.companyId)) return true;
    return 'Sie haben keine Berechtigung, diese Adresse zu löschen';
  }
}